<template>
  <svg
    width="20"
    height="12"
    viewBox="0 0 20 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M19.3374 1.39256C19.4727 0.969532 19.3374 0.658691 18.6938 0.658691H16.5656C16.0244 0.658691 15.775 0.927212 15.6397 1.22331C15.6397 1.22331 14.5574 3.69797 13.0242 5.30543C12.5281 5.77074 12.3026 5.91878 12.0321 5.91878C11.8968 5.91878 11.701 5.77073 11.701 5.34775V1.39256C11.701 0.884928 11.5439 0.658691 11.0929 0.658691H7.74855C7.41039 0.658691 7.20701 0.894294 7.20701 1.11758C7.20701 1.5988 7.97357 1.70978 8.05259 3.06346V6.00342C8.05259 6.648 7.9285 6.76487 7.65792 6.76487C6.93644 6.76487 5.18142 4.27915 4.14053 1.43484C3.93654 0.882007 3.73194 0.658691 3.18802 0.658691H1.05977C0.451699 0.658691 0.330078 0.927212 0.330078 1.22331C0.330078 1.7521 1.0516 4.37481 3.68961 7.84354C5.44827 10.2124 7.92611 11.4965 10.1808 11.4965C11.5337 11.4965 11.701 11.2113 11.701 10.72V8.92965C11.701 8.35924 11.8292 8.2454 12.2576 8.2454C12.5732 8.2454 13.1144 8.39345 14.377 9.53559C15.82 10.8892 16.0579 11.4965 16.8696 11.4965H18.9979C19.6059 11.4965 19.91 11.2113 19.7346 10.6485C19.5427 10.0875 18.8537 9.27362 17.9395 8.30884C17.4434 7.75893 16.6994 7.16673 16.4739 6.87056C16.1582 6.48989 16.2484 6.32065 16.4739 5.98227C16.4739 5.98227 19.0669 2.55583 19.3374 1.39256Z"
      fill="white"
    />
  </svg>
</template>

<script>
export default {
  name: "IconVK",
};
</script>

<style scoped></style>
